import { FaRegCircleCheck } from "react-icons/fa6";
import { FaRegTimesCircle } from "react-icons/fa";
import ClipBoardIcon from "../../../../icons/clipBoardIcon";
import { LuCalendarDays } from "react-icons/lu";

const PrevRequestsTab = ({ t }) => {
  const requests = [
    { date: "01-05-2025", name: "صرف عهدة - (لابتوب – MacBook Pro)", status: true },
    { date: "01-05-2025", name: "إجازة مرضية", status: false },
    { date: "01-05-2025", name: "طلب سلفة", status: true },
    { date: "01-05-2025", name: "تقييم ترقية", status: true },
  ];
  return (
    <div className="bg-[#182443] p-8 rounded-lg space-y-4">
      <h3 className="text-lg font-bold">{t("prevRequests")}</h3>
      <div>
        <section>
          {requests.map((r, i) => {
            const status = {
              bg: r.status ? "#EBFFF6" : "#FFF1F1",
              text: r.status ? t("accepted") : t("rejected"),
              color: r.status ? "#19B36E" : "#C42E27",
              icon: r.status ? (
                <FaRegCircleCheck className="text-[#19B36E]" />
              ) : (
                <FaRegTimesCircle className="text-[#C42E27]" />
              ),
            };
            return (
              <div
                key={i}
                className="p-6 mt-6 rounded-lg border border-[#D1A85533 ] flex justify-between items-center"
              >
                <div className="flex items-center gap-4">
                  <span className="grid place-content-center size-10 rounded-xl bg-primary ">
                    <ClipBoardIcon />
                  </span>

                  <div>
                    <p className="font-semibold">{r.name}</p>
                    <p className="flex items-center gap-2">
                      <LuCalendarDays />
                      {r.date}
                    </p>
                  </div>
                </div>
                <span
                  className="flex rounded-full justify-center text-xs items-center gap-1 min-w-[70px] py-1"
                  style={{ color: status.color, backgroundColor: status.bg }}
                >
                  {status.icon}
                  {status.text}
                </span>
              </div>
            );
          })}
        </section>
      </div>
    </div>
  );
};

export default PrevRequestsTab;
